import Button from '@/components/UI/Button';
import Table from '@/components/UI/Table';
import { userRoles } from '@/referenceData/study/user';
import { useDispatch } from 'react-redux';
import { type TanStackColumnDef } from '@/components/UI/Table/TableComponent.model';
import { type FC } from 'react';

interface User {
  id: string;
  email: string;
  name?: string;
  access: string;
}

interface ShowHiddenUsersProps {
  users: Array<User>;
  author?: User;
  owner?: User;
  title: string;
}

const ShowHiddenUsers: FC<ShowHiddenUsersProps> = ({ users, author, owner, title }) => {
  const dispatch = useDispatch();

  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (owner) {
    users = [
      {
        id: owner.id,
        email: owner.email,
        name: owner.name,
        access: 'owner',
      },
      ...users,
    ];
  }

  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (author) {
    users = [
      {
        id: author.id,
        email: author.email,
        name: author.name,
        access: 'author',
      },
      ...users,
    ];
  }

  const closeModal = () => {
    dispatch({
      type: 'CLOSE_MODAL',
    });
  };

  const columns: Array<TanStackColumnDef<User>> = [
    {
      id: 'user',
      header: 'User',
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      accessorFn: (row: User) => row.name || row.email,
      isVisible: true,
      enableSorting: true,
    },
    {
      id: 'permission',
      header: 'Permissions',
      accessorFn: (row: User) => userRoles[row.access],
      isVisible: true,
      enableSorting: true,
    },
  ];

  return (
    <div className="br2 overflow-hidden bg-near-white w-100 mw6 pa0 center mv3 shadow-4" style={{ paddingBottom: '0' }}>
      <div className="pa3 bb bg-white">
        <h3 className="basier-med normal f4 lh-title near-black">{title}</h3>
      </div>
      <div className="flex flex-wrap justify-between items-top">
        <div className="w-100 bg-white">
          <Table data={users} columns={columns} />
        </div>
      </div>
      <div className="pa3 bt bg-white b--moon-gray">
        <Button plain onClick={closeModal}>
          Close
        </Button>
      </div>
    </div>
  );
};

export default ShowHiddenUsers;
